<template>
  <a-radio-group class="align" :value="field.value" @change="handleChangeInternal">
    <a-button-group>
      <a-tooltip :title="t('propsEditor.alignLeft')">
        <a-button>
          <a-radio value="left">
            <AlignLeftOutlined />
          </a-radio>
        </a-button>
      </a-tooltip>
      <a-tooltip :title="t('propsEditor.alignCenter')">
        <a-button>
          <a-radio value="center">
            <AlignCenterOutlined />
          </a-radio>
        </a-button>
      </a-tooltip>
      <a-tooltip :title="t('propsEditor.alignRight')">
        <a-button>
          <a-radio value="right">
            <AlignRightOutlined />
          </a-radio>
        </a-button>
      </a-tooltip>
    </a-button-group>
  </a-radio-group>
</template>
<script>
import { ref, watch } from 'vue';
import { props } from './helper';
import { AlignLeftOutlined, AlignCenterOutlined, AlignRightOutlined } from '@ant-design/icons-vue';
import i18n from '@/locales/i18n';

const { t } = i18n.global;
export default {
  components: { AlignLeftOutlined, AlignCenterOutlined, AlignRightOutlined },
  props,
  setup(props) {
    const handleChangeInternal = e => {
      props.handleChange(e.target.value);
    };

    return {
      t,
      handleChangeInternal,
    };
  },
};
</script>
<style lang="less" scoped>
.align {
  ::v-deep(.ant-radio) {
    display: none;
  }
}
.ant-radio-wrapper-checked {
  color: #fff;
  background: @primary-color;
}
.ant-btn {
  padding: 0;
}
.ant-radio-wrapper {
  display: flex;
  height: 100%;
  margin: 0;
  padding: 0 5px;
  align-items: center;
}
</style>
